module.exports = __webpack_public_path__ + "static/img/banner_zyb.094b7784.jpg";